{
  "header": "Detail Aset",
  "subtitle": "Aset yang terpasang pada truk Anda (trailer, kontainer, dll).",
  "assetType": "Jenis Aset",
  "assetTypePlaceholder": "Pilih jenis Aset",
  "assetId": "ID Aset (mis. Nomor Trailer)",
  "assetIdPlaceholder": "Mis.: Nomor trailer, ID kontainer, dll",
  "remove": "Hapus",
  "addAnother": "Tambah aset lain",
  "trailerType": "Jenis trailer",
  "trailerId": "ID Trailer"
}
